"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxLabelIncidentPackageMappingJobErrorCode = void 0;
var BoxLabelIncidentPackageMappingJobErrorCode;
(function (BoxLabelIncidentPackageMappingJobErrorCode) {
    BoxLabelIncidentPackageMappingJobErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    BoxLabelIncidentPackageMappingJobErrorCode["NO_MAPPABLE_CDSKUS"] = "NO_MAPPABLE_CDSKUS";
    BoxLabelIncidentPackageMappingJobErrorCode["UNABLE_TO_SYNC_INBOUND_PACKAGES"] = "UNABLE_TO_SYNC_INBOUND_PACKAGES";
    BoxLabelIncidentPackageMappingJobErrorCode["ATTEMPTING_TO_MAP_ACROSS_SELLERS"] = "ATTEMPTING_TO_MAP_ACROSS_SELLERS";
    BoxLabelIncidentPackageMappingJobErrorCode["ATTEMPTING_TO_MAP_ACROSS_SHIPPING_PLANS"] = "ATTEMPTING_TO_MAP_ACROSS_SHIPPING_PLANS";
})(BoxLabelIncidentPackageMappingJobErrorCode = exports.BoxLabelIncidentPackageMappingJobErrorCode || (exports.BoxLabelIncidentPackageMappingJobErrorCode = {}));
//# sourceMappingURL=BoxLabelIncidentPackageMappingJobErrorCode.js.map